import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as units from 'store/units/actions';
import { FormBody } from 'common/components/drawer';
import selectDataFromState from 'utils/selectDataFromState';
import EditVisibilityForm from 'components/drawers/EditCompanyVisibility';
import { strToNumber } from 'common/utils/numbers';

import config from './unit/config';
import Units from './unit';

const EditUnits = ({ drawer, active, editType, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateUnits, createUnits] = useActions([units.updateUnits, units.createUnits]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active && isOpen) {
      const params = {
        ...active
      };

      const initialValues = selectDataFromState(params, config);

      loadValues({ ...initialValues });
    }

    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { ratio, ...rest } = values;

    const params = {
      ...rest,
      id: active ? active.id : undefined,
      ratio: ratio ? strToNumber(ratio) : null,
      table: 'units'
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updateUnits(params);
      } else {
        await createUnits(params);
        resetForm();
        refetchData();
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return active && editType === 'visibility' ? (
    <EditVisibilityForm drawer={drawer} active={active} isOpen={drawer.isOpen} type="enums/units" />
  ) : (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Unit'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <Units formState={formState} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditUnits;
